import { ColumnTypes, FilterTypes } from "commons/table/Constants";
import { DateConstants } from "lookup/DateConstants";
import { formatDateForDisplay } from "services/MomentUtils";
import ProtectedHealthInformation from "components/SwitchDetails/ProtectedHealthInformation";
import EditableCloseReason from "components/EditableCloseReason/EditableCloseReason";
import HscSwitchListNotes from "components/SwitchDetails/HscSwitchListNotes";
import { CLOSE_REASONS_FOR_SELECT } from "lookup/CloseReasonConstants";
import './HscSwitchList.css';

export const COLUMN = {
  customerNameAbbreviation: "customerNameAbbreviation",
  clientNameAbbreviation: "clientNameAbbreviation",
  switchNumber: "switchNumber",
  prescriberName: "prescriberName",
  prescriberFax: "prescriberFax",
  prescriberPhone: "prescriberPhone",
  prescriberNPI: "prescriberNPI",
  memberPhi: "memberPhi",
  closeReason: "closeReason",
  processedDate: "processedDate",
  notes: "notes",
};

export const createColumnListForSwitchList = (
  columns = [],
  enableSortFilterForCust = true,
  onNoteUpdate,
  onConfirm
) => {
  let columnList = [];
  for (const element of columns) {
    switch (element) {
      case COLUMN.memberPhi:
        columnList.push({
          header: "Member PHI",
          accessor: "memberPhi",
          accessorKey: "memberPhi",
          width: 140,
          enableSorting: false,
          enableColumnFilter: false,
          columnType: ColumnTypes.Custom,
          customComponent: (value, row) => {
            return (
              <div onClick={(e) => e.stopPropagation()}>
                <ProtectedHealthInformation
                  globalSwitchId={row.original.globalSwitchId}
                />
              </div>
            );
          },
        });
        break;
      case COLUMN.closeReason:
        columnList.push({
          header: "Close Reason",
          accessor: "closeReason",
          accessorKey: "closeReason",
          width: 200,
          enableSorting: false,
          enableColumnFilter: true,
          filterType: FilterTypes.SingleSelect,
          filterOptions: [{ label: "-- DEFAULT --", value: "DEFAULT" }, {label: "-- Not Selected", value: "Not Selected"}, ...CLOSE_REASONS_FOR_SELECT],
          columnType: ColumnTypes.Custom,
          customComponent: (value, row) => {
            return (
              <div onClick={(e) => e.stopPropagation()}>
                <EditableCloseReason
                  globalSwitchId={row.original.globalSwitchId}
                  closeReason={row.original.closeReason}
                  wfItemId={row.original.wfItemId}
                  onConfirm={onConfirm}
                />
              </div>
            );
          },
        });
        break;

      case COLUMN.processedDate:
        columnList.push({
          header: "Processed",
          accessor: "processedDate",
          accessorKey: "processedDate",
          width: 110,
          enableSorting: true,
          enableColumnFilter: false,
          columnType: ColumnTypes.Custom,
          filterType: FilterTypes.SearchableInput,
          customComponent: (value, row) => {
            return renderLastModifiedDateCol(
              row.original.processedDate
            );
          },
        });
        break;
      case COLUMN.notes:
        columnList.push({
          header: "Notes",
          accessor: "notes",
          accessorKey: "notes",
          width: 250,
          enableSorting: false,
          enableColumnFilter: false,
          columnType: ColumnTypes.Custom,
          customComponent: (value, row) => {
            return (
              <div onClick={(e) => e.stopPropagation()}>
                <HscSwitchListNotes
                  wfItemId={row.original.wfItemId}
                  latestNote={row.original.latestNote}
                  onNoteUpdate={onNoteUpdate}
                />
              </div>
            );
          },
        });
        break;
      case COLUMN.customerNameAbbreviation:
        columnList.push({
          header: "Customer",
          accessor: "customerNameAbbreviation",
          accessorKey: "customerNameAbbreviation",
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
        });
        break;
      case COLUMN.clientNameAbbreviation:
        columnList.push({
          header: "Client",
          accessor: "clientNameAbbreviation",
          accessorKey: "clientNameAbbreviation",
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
        });
        break;
      case COLUMN.switchNumber:
        columnList.push({
          header: "Switch Id",
          accessor: "switchNumber",
          accessorKey: "switchNumber",
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
        });
        break;
      case COLUMN.prescriberName:
        columnList.push({
          header: "Prescriber",
          accessor: "prescriberName",
          accessorKey: "prescriberName",
          width: 245,
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
        });
        break;
      case COLUMN.pharmacyPhone:
        columnList.push({
          header: "Pharmacy #",
          accessor: "pharmacyPhone",
          accessorKey: "pharmacyPhone",
          width: 90,
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
          show: true,
        });
        break;
      case COLUMN.prescriberNPI:
        columnList.push({
          header: "Prescriber NPI",
          accessor: "prescriberNpi",
          accessorKey: "prescriberNpi",
          width: 90,
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
          show: true,
        });
        break;
      case COLUMN.prescriberFax:
        columnList.push({
          header: "Prescriber Fax",
          accessor: "prescriberFax",
          accessorKey: "prescriberFax",
          width: 90,
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
          show: true,
        });
        break;
      case COLUMN.prescriberPhone:
        columnList.push({
          header: "Prescriber Phone",
          accessor: "prescriberPhone",
          accessorKey: "prescriberPhone",
          width: 90,
          enableSorting: true,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
          show: true,
        });
    }
  }
  return columnList;
};

const renderDateCell = (date) => {
  return (
    <span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      {date}
    </span>
  );
};

const renderEffectiveDateCol = (date, days) => {
  if (date) {
    const status = days >= 0 ? "ComingDue" : "PastDue";
    return renderEffectiveDateCell(formatDateForDisplay(date), status);
  }
};

const renderEffectiveDateCell = (date, status) => {
  return (
    <span
      style={{ width: "100%", display: "inline-block", textAlign: "center" }}
    >
      <span style={{ color: DateConstants.statusColors[status] }}>
        &#x25cf; &nbsp;
      </span>
      {date}
    </span>
  );
};

const renderLastModifiedDateCol = (date, days) => {
  if (date) {
    return renderDateCell(formatDateForDisplay(date));
  }
  return <span className="center">N/A</span>;
};